export var FormFieldCategory;
(function (FormFieldCategory) {
    FormFieldCategory["Booking"] = "BOOKING";
    FormFieldCategory["Payment"] = "PAYMENT";
    FormFieldCategory["Registration"] = "REGISTRATION";
    FormFieldCategory["SiteProduct"] = "SITE_PRODUCT";
    FormFieldCategory["Team"] = "TEAM";
    FormFieldCategory["UserProfile"] = "USER_PROFILE";
})(FormFieldCategory || (FormFieldCategory = {}));
export var WaiverType;
(function (WaiverType) {
    WaiverType["Payment"] = "PAYMENT";
    WaiverType["Main"] = "MAIN";
    WaiverType["Custom"] = "CUSTOM";
})(WaiverType || (WaiverType = {}));
